<template>
		<div class="list--view">

			<div class="single--list-view single--list-view-roles">

            <div class="single--list-view single--list-view-roles">
                <vs-select
                    class="selectExample"
                    v-model="selectTypePerson"
                    @input="statusSelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in optionsTypePerson" />
                    </vs-select>
            </div>
      </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                selectTypePerson: this.getSelectedTypePerson(),
                optionsTypePerson:[

                    {value: '0', label: this.__("misc.actuals"), isSelected: true },
                    {value: '1', label: this.__("misc.history"), isSelected: false },
                ],
            }
        },
        methods: {
          getSelectedTypePerson(){
            let resignedValue = '0';
            if (location.search.indexOf("resigned") >= 0 ){
              resignedValue = (/resigned=([^&]+)/.exec(location.href)[1] === "1") ? '1' : '0';
            }
            return resignedValue;
          },
          statusSelected(selectedOption, id) {

              if (selectedOption === 'all') {
                location.href = app.__vue__.removeParam("resigned");
              } else if (selectedOption == "1") {
                location.href = app.__vue__.addParam("resigned", "1");
              } else if (selectedOption == "0") {
                  location.href = app.__vue__.addParam("resigned", "0");
              }
            },

        },
        mounted(){

        }

    }
</script>
